<div class="p-5 text-center">
    <h3>The transaction was unsuccessful due to one of the following reasons:</h3>
    <h3>Payment was canceled, rejected, failed or transaction expired.</h3>
</div>
